import { useOptimizedRecords } from '@/shared/hooks/useOptimizedQuery'

import type { MissionSubmissionEntry } from '../types'

/**
 * Submissions do próprio aluno para uma missão de evidência, com o material
 * enviado. Alimenta o modal aberto ao clicar numa linha de Missão de evidência.
 */
export function useMissionSubmissions(missionId: number | null) {
  const query = useOptimizedRecords<MissionSubmissionEntry>({
    path: '/user/content_history/mission_submissions',
    params: missionId != null ? { mission_id: missionId } : undefined,
    enabled: missionId != null,
    skipInitialData: true
  })

  return {
    ...query,
    submissions: query.records as MissionSubmissionEntry[]
  }
}
